import { BaseSettingsClient, AppSettings } from "@core/types";

class SettingsClient extends BaseSettingsClient {
  async getSettings(): Promise<Partial<AppSettings> | null> {
    return null;
  }
}

export default SettingsClient;
